import { render, staticRenderFns } from "./ContactColombia.vue?vue&type=template&id=f853d1f4&"
import script from "./ContactColombia.vue?vue&type=script&lang=ts&"
export * from "./ContactColombia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports